import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../components/index.vue'
import Home from '../components/home.vue'
import We from '../components/we.vue'
import Slution from '../components/slution/slution.vue'
import Slutionindex from '../components/slution/slutionindex.vue'
import Details from '../components/slution/details.vue'
import Detailsother from '../components/slution/detailsother.vue'
import Contact from '../components/contact.vue'
import Product from '../components/product.vue'
import Platform from '../components/product/platform.vue'
import Canteen from '../components/product/canteen.vue'
import Document from '../components/product/document.vue'
import Partybuilding from '../components/product/partybuilding.vue'
import College from '../components/product/college.vue'
import Vote from '../components/product/vote.vue'
import Recruitments from '../components/recruitments.vue'
import Recruit from '../components/recruit.vue'
import Ma from '../components/ma.vue'
import Case from '../components/case.vue'
import News from '../components/news/news.vue'
import Newslist from '../components/news/newslist.vue'
import Newsdetails from '../components/news/newsdetails.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Index,
    redirect: '/home',
    children: [
      {
        path: '/home',
        component: Home
      },
      {
        path: '/we',
        component: We
      },
      {
        path: '/slution',
        component: Slution,
        redirect: '/slutionindex',
        children: [
          {
            path: '/slutionindex',
            component: Slutionindex
          },
          {
            path: '/details',
            component: Details
          },
          {
            path: '/detailsother',
            component: Detailsother
          }
        ]
      },
      {
        path: '/contact',
        component: Contact
      },
      {
        path: '/product',
        component: Product,
        redirect: '/platform',
        children: [
          {
            path: '/platform',
            component: Platform
          },
          {
            path: '/canteen',
            component: Canteen
          },
          {
            path: '/document',
            component: Document
          },
          {
            path: '/partybuilding',
            component: Partybuilding
          },
          {
            path: '/college',
            component: College
          },
          {
            path: '/vote',
            component: Vote
          }
        ]
      },
      {
        path: '/news',
        component: News,
        redirect: '/newslist',
        children: [
          {
            path: '/newslist',
            component: Newslist
          },
          {
            path: '/newsdetails',
            component: Newsdetails
          }
        ]
      },
      {
        path: '/case',
        component: Case
      }
    ]
  },
  {
    path: '/recruitments',
    component: Recruitments
  },
  {
    path: '/recruit',
    component: Recruit
  },
  {
    path: '/ma',
    component: Ma
  }
]

const router = new VueRouter({
  routes
})

export default router
